import React, { useMemo } from 'react';
import { useConfig, RuntimeConfig } from '@occc/config';
import { NotFound } from '../routes/NotFound';

export type ConfigGuardProps = {
  isFeatureEnabled: (config: RuntimeConfig) => boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

export const ConfigGuard = ({ isFeatureEnabled, children, fallback }: ConfigGuardProps) => {
  const { config } = useConfig();
  const shouldRender = useMemo(() => isFeatureEnabled(config), [isFeatureEnabled, config]);

  if (shouldRender) {
    return <>{children}</>;
  }

  return fallback !== undefined ? <>{fallback}</> : <NotFound />;
};
